


























import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { VDialog } from '@bilibili/sakura'
@Component({
  components: {
    VDialog,
  },
})
export default class Dialog extends Vue {
  @State('userInfo') userInfo
  @State('qrCodeImg') qrCodeImg
  @Prop(Boolean)
  visible!: boolean
  @Prop({ type: String, default: '' })
  rank?: string

  @Prop({
    type: Object,
    default: () => {
      return {}
    },
  })
  currShareItem!: any

  get show() {
    return this.visible
  }

  set show(value) {
    this.$emit('update:visible', value)
  }

  get posterStyle() {
    return { backgroundImage: `url(${this.currShareItem.sharePoster})` }
  }

  get bgStyle() {
    return { backgroundImage: `url(${this.qrCodeImg})` }
  }
}
